// Make sure to call Vue.use(Vuex) first if using a module system
import Vue from 'vue';
import Vuex from 'vuex';
import teacher from './modules/teacher';
import throttle from 'lodash/throttle';
import quiz from './modules/quiz';
import student from './modules/student';
import activity from '../refactoring pages/modules/activity-teacher/store/activity';
import newActivityWizard from '../refactoring pages/modules/new-activity-wizard/store/new_activity_wizard';
import assignment from './modules/assignment';
import classes from './modules/classes';
import activity_class_selection from './modules/activity_class_selection';
import { loadState, saveState } from '../localstorage';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const persistedState = loadState() || {};

const store = new Vuex.Store({
  state: persistedState || {
    sign_up: {
      step: 'role-select',
      role: '',
      account: {
        username: '',
        email: '',
        first: '',
        last: '',
        password: '',
        age: '',
      },
      classroom: {
        name: '',
        grade: '',
        school: '',
        under_13: true
      },
      students: [],
    },
  },
  modules: { quiz, teacher, student, assignment, classes, activity_class_selection, activity, newActivityWizard },
  strict: debug
});

store.subscribe(
  throttle((mutation, state) => {
    saveState(state)
  }, 1000)
);

export default store;
